

import {lazy} from "react";
import {usrPermission} from "../../config/userPermission";

const AboutEvents = lazy(() => import("./pages/AboutEvents"));

export const routes: any = [
    {
        path: "about-event",
        permission: usrPermission.event.r,
        element: <AboutEvents />,
    },
];